export default __webpack_public_path__ + "static/dbd-d67dff5819e5f4c108e6666baff4f6ef.jpg";